module.exports = __webpack_public_path__ + "img/icon.f2febf23.png";